// ============================================================
// Only the newest answer gets to speak
// ============================================================
// Two requests for the same screen can be in flight at once — a poll and a
// refresh, or the load that fires before the GPS has answered and the one that
// fires the moment it does. Nothing makes them come back in the order they
// went out, and whichever lands last wins.
//
// That is not theoretical. On the mini-app's board the two finished 0.42 s and
// 0.48 s apart against the live server, so it was a coin toss which one you
// saw: refresh and the cameras were there, refresh and they were gone, refresh
// and they were back.
//
// Usage: make one of these per screen, take a ticket at the start of each
// request, and check it before writing anything.
//
//   const claim = useRef(latestOnly()).current;
//   ...
//   const stale = claim();
//   const data = await fetch(...);
//   if (stale()) return;          // something newer is already on its way

export function latestOnly() {
  let issued = 0;
  return function claim() {
    const ticket = ++issued;
    // Read at the moment of asking, not at the moment of claiming — a request
    // is only stale once a *later* one has started.
    return () => ticket !== issued;
  };
}
